import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class LeftAsideService {
  getDeviceData() {
    throw new Error("Method not implemented.");
  }

// shar live data througout the activity
public  liveDataObs = new BehaviorSubject('liv data');
livedataSubs = this.liveDataObs.asObservable();
  AppDataServiceService: any;

setliveData(message) {
  this.liveDataObs.next(message)
}

  private messageSource = new BehaviorSubject('default message');
  currentMessage = this.messageSource.asObservable();

  changeMessage(message) {
    this.messageSource.next(message)
  }

  /****************** on click change group ****************** */
  private componentMethodCallSource = new Subject<any>();
  // Observable string streams
  componentMethodCalled$ = this.componentMethodCallSource.asObservable();

  // Service message commands
  callComponentMethod(data:any) {
    this.componentMethodCallSource.next(data);
  }
 /************************************ */

   /****************** st header date ****************** */
   private setHeaderData = new Subject<any>();
   // Observable string streams
   setHeaderDataMethodCalled$ = this.setHeaderData.asObservable();
 
   // Service message commands
   setHeaderDataMethod(data:any) {
     this.setHeaderData.next(data);
   }
  /************************************ */

  // *************** Device List *********

  public deviceDetails = new BehaviorSubject('device_details');
  deviceDetailsMessage = this.deviceDetails.asObservable();

  setdeviceDetails(data:any) {
    this.deviceDetails.next(data)
  }


  constructor() { }
  getLeftAsideData(){
    return [
      {"name":"critical","unit":"kw","val":"171999","id":"critical-1","Yesterday":"1234"},
      {"name":"critical","unit":"kw","val":"171999","id":"critical-2","Yesterday":"1234"},
      {"name":"critical","unit":"kw","val":"171999","id":"critical-3","Yesterday":"1234"},
      {"name":"critical","unit":"kw","val":"171999","id":"critical-4","Yesterday":"1234"},
      {"name":"critical","unit":"kw","val":"171999","id":"critical-5","Yesterday":"1234"},
      {"name":"critical","unit":"kw","val":"171999","id":"critical-6","Yesterday":"1234"},
    ]
  }
}
